function highlightVariantsInCart11() {
    var allVariantIds = [];

  $('.pdp_main_product .upsell_tab_wrapper .upsell_product_item').each(function() {
    var variantId = parseInt($(this).find('.input_data_all').attr('value-data'));
    allVariantIds.push(parseInt(variantId));
  });


  $.getJSON('/cart.js', function(cart) {
    var cartVariantIds = cart.items.map(function(item) {
      return item.variant_id;
    });

    var matchedVariantIds = allVariantIds.filter(function(id) {
      return cartVariantIds.includes(id);
    });
 $('.pdp_main_product .upsell_tab_wrapper .upsell_product_item').removeClass('show_datta');
    if (matchedVariantIds.length > 0) {
      console.log('Matched variant IDs:', matchedVariantIds);

      $('.pdp_main_product .upsell_tab_wrapper .upsell_product_item').each(function() {
       
    var variantId = parseInt($(this).find('.input_data_all').attr('value-data'));
        if (matchedVariantIds.includes(variantId)) {
          $(this).addClass('show_datta');
        }
      });
    } else {
 $('.pdp_main_product .upsell_tab_wrapper .upsell_product_item').removeClass('show_datta');
    }
  });
}

highlightVariantsInCart11();






  $('.upsell_product_item svg.plus').on('click', function(e) {
    e.preventDefault();
  
    var $wrapper = $(this).closest('.upsell_product_item');
   
    var id_data = $wrapper.find('.input_data_all').attr('value-data');


  // Add to cart using Shopify AJAX API
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
        id: id_data,
        quantity: 1
      },
    dataType: 'json',
    success: function(item) {
      console.log('Added to cart:', item);
      window.location.href = '/checkout';
    },
    error: function(xhr, status, error) {
      console.error('Error adding to cart:', error);
      // alert('Sorry, something went wrong adding to cart.');
    }
  });


  });





$(document).on('click', '.upsell_product_item svg.minus', function(e) {
  e.preventDefault();

    var data_all = $(this).closest('.upsell_product_item').find('.input_data_all').attr('value-data');
  // alert('data_all', data_all);
$('.js-mini-cart-content .mini-cart-item[var_id="'+data_all+'"] button.btn.js-remove-mini-cart').click();
$('.js-mini-cart-content button.btn.js-remove-mini-cart[data-id="'+data_all+'"]').click();
  
    setTimeout(function() {
  highlightVariantsInCart11();
            },1000);
});

